module.exports = __webpack_public_path__ + "static/media/pickle_3_kg.b2ebcfb9.png";